// Query keys factory for provider contracts

export const providerContractQKeys = {
  all: () => ["provider-contracts"] as const,

  lists: () => [...providerContractQKeys.all(), "list"] as const,

  list: (filters: { provider?: string; service?: string }) =>
    [...providerContractQKeys.lists(), { ...filters }] as const,

  details: () => [...providerContractQKeys.all(), "detail"] as const,

  detail: (contractId: string) =>
    [...providerContractQKeys.details(), contractId] as const,

  byProvider: (providerId: string) =>
    [...providerContractQKeys.all(), "by-provider", providerId] as const,

  byService: (serviceId: string) =>
    [...providerContractQKeys.all(), "by-service", serviceId] as const,
};
